<script lang="ts">
  import config from 'config'
</script>

<a href="/">
  <h1 class="sr-only">Data Basin</h1>
  <img src={config.logo} alt="Data Basin" aria-hidden="true" />
</a>

<style lang="scss">
  a {
    text-decoration: none;

    img {
      height: 50px;
      padding: 10px 5px 20px 20px;
    }
  }
</style>
